import { Group } from '@visx/group'
import type { HierarchyPointLink } from '@visx/hierarchy'
import { LinkHorizontalStep, Polygon } from '@visx/shape'

import { LINK_ARROW_RADIUS } from './constants'
import type { TreeNode } from './types'

type Offset = {
  dy: number
  dx: number
}

type Props = {
  /** Externally defined line class names */
  lineClassName: string
  /** Link item */
  link: HierarchyPointLink<TreeNode>
  /** Offset applied to the source connector */
  sourceConnectorOffset?: Offset
  /** Offset applied to the target connector */
  targetConnectorOffset?: Offset
  /** Percentage step used for the step line */
  percent?: number
}

/**
 * Renders a HorizontalStep line from Visx, including connectors that are relevant to the configuration portal diagrams.
 */
export const SubTemplateTreeLink = ({
  lineClassName,
  link: originalLink,
  sourceConnectorOffset,
  targetConnectorOffset,
  percent = 0,
}: Props) => {
  const link = {
    source: {
      x: originalLink.source.x + (sourceConnectorOffset?.dy || 0),
      y: originalLink.source.y + (sourceConnectorOffset?.dx || 0),
    },
    target: {
      x: originalLink.target.x + (targetConnectorOffset?.dy || 0),
      y: originalLink.target.y + (targetConnectorOffset?.dx || 0),
    },
  }

  return (
    <Group>
      <LinkHorizontalStep
        data={link}
        className={lineClassName}
        percent={percent}
      />
      {originalLink.source.data.isReplacement ? (
        <Polygon
          sides={3}
          className="fill-subtemplateLine stroke-subtemplateLine"
          size={LINK_ARROW_RADIUS}
          rotate={90}
          center={{
            x: link.source.y,
            y: link.source.x + LINK_ARROW_RADIUS / 2,
          }}
        />
      ) : (
        <Polygon
          sides={3}
          className="fill-subtemplateLine stroke-subtemplateLine"
          size={LINK_ARROW_RADIUS}
          center={{
            x: link.target.y - LINK_ARROW_RADIUS,
            y: link.target.x,
          }}
        />
      )}
    </Group>
  )
}
